var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "115718_location_map_pin_icon (1) 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 11.0913C12.0691 11.0913 13.751 9.40881 13.751 7.34131C13.751 5.27381 12.0691 3.59131 10.001 3.59131C7.93285 3.59131 6.25098 5.27318 6.25098 7.34131C6.25098 9.40943 7.93285 11.0913 10.001 11.0913ZM10.001 4.21631C11.7247 4.21631 13.126 5.61756 13.126 7.34131C13.126 9.06506 11.7247 10.4663 10.001 10.4663C8.27723 10.4663 6.87598 9.06506 6.87598 7.34131C6.87598 5.61756 8.27723 4.21631 10.001 4.21631Z",
    fill: "#134563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C5.86375 0 2.5 3.3225 2.5 7.50063C2.5 11.8756 6.25062 16.3512 8.985 19.4969C8.995 19.5094 9.43375 20 9.97625 20C9.9775 20 10.0219 20 10.0244 20C10.5662 20 11.0056 19.5094 11.0156 19.4969C13.7512 16.3512 17.5012 11.8763 17.5012 7.50063C17.5012 3.3225 14.1369 0 10 0ZM10.0731 18.6769C10.06 18.6894 10.0219 18.7169 9.98875 18.7381C9.9825 18.7213 9.93625 18.6844 9.90812 18.655C7.6175 16.0194 3.75 11.5712 3.75 7.50063C3.75 4.05438 6.55437 1.25 10 1.25C13.4475 1.25 16.2512 4.05438 16.2512 7.50125C16.2512 11.5712 12.3837 16.0194 10.0731 18.6769Z",
    fill: "#134563"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bc7b86c47dec02366da0878ef8c052df.svg";
export { ForwardRef as ReactComponent };